const OR = (leftCondition: boolean, rightCondition: boolean) => leftCondition || rightCondition;

export default OR;
